<script>
    import meetups from './meetups-store';
    import {createEventDispatcher} from "svelte";
    import TextInput from "../UI/TextInput.svelte";
    import Button from "../UI/Button.svelte";
    import Modal from "../UI/Modal.svelte";
    import {isEmpty, isValidEmail} from '../helpers/validation';
   
export let id = null;

//let titleValid = false;
//let subtitleValid = false;
//let addressValid = false;
//let urlValid = false;
//let emailValid = false;                     //TODAS ESTAS VALIDACIONES SE PUEDEN OMITIR DEBIDO A QUE LAS
//let descriptionValid = false;                 //ESTAMOS UTILIZANDO CON $: Y ESTO SVELTE LO ENTIENDE Y LAS INICIALIZA
//let formIsvalid = false;
let title = "";
let subtitle = "";
let address = "";
let email = "";
let description = "";
let imageUrl = "";

if(id){
   const unsubscribe = meetups.subscribe(items =>{
    const selectedMeetup = items.find (i => i.id == id);
        title = selectedMeetup.title;
        subtitle = selectedMeetup.subtitle;
        address = selectedMeetup.address;
        email = selectedMeetup.contactEmail;
        description = selectedMeetup.description;
        imageUrl = selectedMeetup.imageUrl;
    });
    unsubscribe();
}

const dispatch = createEventDispatcher();

$: titleValid = !isEmpty(title);
$: subtitleValid = !isEmpty(subtitle);
$: addressValid = !isEmpty(address);
$: urlValid = !isEmpty(imageUrl);
$: emailValid = isValidEmail(email);
$: descriptionValid = !isEmpty(description);
$: formIsvalid =
 titleValid && 
 subtitleValid && 
 addressValid && 
 urlValid && 
 descriptionValid && 
 emailValid;



function cancel(){
    dispatch('cancel');
}

function submitForm(){
    const meetupData ={

    title: title,
    subtitle: subtitle,
    description: description,
    imageUrl: imageUrl,
    contactEmail: email,
    address: address
  };

     //meetups.push(newMeetup); // DOES NOT WORK FOR svelte

     if(id){
        fetch(`https://meetups-c7487-default-rtdb.firebaseio.com/meetups/${id}.json`,{
            method: 'PATCH',
            body: JSON.stringify(meetupData),
            headers: { 'Content-Type': 'application/json'}
        }).then(res => {
            if(!res.ok){
                throw new Error('Fail');
            }
            meetups.updateMeetup(id,meetupData);
        }).catch(err => {
            console.log(err);
        });
        
     }else{
        fetch('https://meetups-c7487-default-rtdb.firebaseio.com/meetups.json',{
            method: 'POST',
            body: JSON.stringify({...meetupData,isFavorite: false}),
            headers: { 'Content-Type': 'application/json'}
        }).then(res => {
            if(!res.ok){
                throw new Error('Fail');
            }
            return res.json();
        })
        .then(data => {
            meetups.addMeetup({
                ...meetupData, 
                isFavorite: false, 
                id: data.name
            });
        })
        .catch(err =>{
            console.log(err);
        })
        
     }
    
    dispatch('save');
}

function deleteMeetup(){
    fetch(`https://meetups-c7487-default-rtdb.firebaseio.com/meetups/${id}.json`,{
            method: 'DELETE',
            }).then(res => {
                if(!res.ok){
                throw new Error('Fail');
            }
            meetups.removeMeetup(id);
            }).catch(err =>{
            console.log(err);
        });
    
    dispatch('save');
}
</script>
<style>
     form{
      width:100%;
     
    }
</style>
<Modal title="Edit Meetup Data" on:cancel>
    <form on:submit|preventDefault={submitForm}>
        <TextInput id="title" label="Title"  value={title} valid={titleValid} validityMessage="Please enter a valid tittle." on:input={event => (title = event.target.value)}/>
        <TextInput id="subtitle" label="Subtitle"  value={subtitle} valid={subtitleValid} validityMessage="Please enter a valid subtittle." on:input={event => (subtitle = event.target.value)}/>
        <TextInput id="address" label="Address"  value={address} valid={addressValid} validityMessage="Please enter a valid adress." on:input={event => (address = event.target.value)}/>
        <TextInput id="imageUrl" label="Image Url"  value={imageUrl} valid={urlValid} validityMessage="Please enter a valid url." on:input={event => (imageUrl = event.target.value)}/>
        <TextInput id="email" label="Email" type="email" value={email} valid={emailValid} validityMessage="Please enter a valid email." on:input={event =>(email = event.target.value)}/>
        <TextInput id="description" label="Description" controlType="textarea" value={description} valid={descriptionValid} validityMessage="Please enter a valid description." on:input={event => (description = event.target.value)}/>
       
    </form>
     <div slot="footer">
        <Button type="button" mode='outline'on:click={cancel}>Cancel</Button>
        <Button type="button" on:click={submitForm} disabled={!formIsvalid}>Save</Button>
        {#if id}
        <Button type="button" on:click={deleteMeetup}>Delete</Button>
        {/if}
     </div>
        
</Modal>